import { useEffect } from 'react';

function useFocusTab({ isTabFocused, tabsRef, setFocusedTabIndex, context }, [...deps]) {
    const getTabIndexByKey = (tabKey) => {
        return tabsRef.current.findIndex((el) => {
            return el.id === tabKey;
        });
    };
    useEffect(() => {
        if (!isTabFocused) {
            const currentFocusedTabIndex = getTabIndexByKey(context.currentTab);
            setFocusedTabIndex(currentFocusedTabIndex);
        }
    }, [deps]);
}

export { useFocusTab };
